import { Typography } from '@material-ui/core'
import React from 'react'
import PropTypes from 'prop-types'
import logo from '../../assets/img/encontruccion.png'
import './WrapperImg.scss'

export const WrapperImg = ({ children, title, text }) => {
  return (
    <section className="wrapper">
      <div className="wrapper__text">
        <Typography variant="h3" gutterBottom>
          {title}
        </Typography>
        <span>{text}</span>
        <br />
        {children}
      </div>
      <div className="wrapper__img">
        <img src={logo} alt="welcome-BCIE" />
      </div>
    </section>
  )
}
WrapperImg.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  children: PropTypes.node
}